import React, { Component } from 'react';
// import ParticlesBg  from "particles-bg";
import ParticlesBg from "particles-bg"


class Header extends Component {
   constructor(props) {
      super(props);
      this.state = { windowWidth: window.innerWidth };
    }
  
   getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }
   getWidth(){
      if(this.state.windowWidth > 900){
         return 200;
      }else{
         return 50;
      }
   }
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var description= this.props.data.description;
      // var city= this.props.data.address.city;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a target="_blank" rel="noreferrer" href={network.url}><i className={network.className}></i></a></li>
      })
    }
   //  console.log(this.state.windowWidth);
    

    return (
      <header id="home">
      <ParticlesBg color={this.getRandomColor()} type="cobweb" num={this.getWidth()} bg={true} />

      <nav id="nav-wrap">
         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">About</a></li>
	         <li><a className="smoothscroll" href="#resume">Resume</a></li>
            <li><a className="smoothscroll" href="#portfolio">Works</a></li>
            <li><a className="smoothscroll" href="#contact">Contact</a></li>
         </ul>
      </nav>

      <div className="row banner">
      
         <div className="banner-text">
            <h1 className="responsive-headline">{name}</h1>
            <h3>{description}.</h3>
            <hr />
            <ul className="social">
               {networks}
               {/* <a href={project} className="button btn project-btn"><i className="fa fa-book"></i>Project</a>
               <a href={github} className="button btn github-btn"><i className="fa fa-github"></i>Github</a> */}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
